"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Li = exports.Ul = exports.UlCollapsed = exports.HeaderAlone = exports.Header = exports.FloatingContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.FloatingContainer = styled_components_1.default.div `
  box-sizing: border-box;

  /* width is 200px @ 16px base font size and 268px @ 32px base font-size */
  ${({ hasChildren }) => hasChildren && 'width: calc(132px + 4.25rem);'}
  padding: ${({ theme }) => `${theme.spacing02} ${theme.spacing03}`};

  display: flex;
  flex-direction: column;

  border-radius: 6px;
  border: ${({ theme }) => `1px solid ${theme.ui01}`};
  background-color: ${({ theme }) => theme.ui06};
  box-shadow: ${({ theme }) => theme.shadowLow};
`;
exports.Header = styled_components_1.default.div `
  padding: 8px 16px;
  ${({ theme }) => theme.bodyBold01};
`;
exports.HeaderAlone = styled_components_1.default.div `
  padding: 8px;
  ${({ theme }) => theme.bodyBold01};
`;
exports.UlCollapsed = styled_components_1.default.ul `
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${({ theme }) => theme.ui01};
  gap: 4px;
`;
exports.Ul = styled_components_1.default.ul `
  border-left: 1px solid ${({ theme }) => theme.ui02};
  position: relative;
  margin-left: 17px;
  padding-left: 7px;
  list-style-type: none;
  display: flex;
  gap: 4px;
  flex-direction: column;
`;
exports.Li = styled_components_1.default.li `
  display: block;
`;
